import React from 'react'
import { signOut } from "firebase/auth";
import { Text } from '@chakra-ui/react';
import { auth } from '../../services/auth';

export const SignOut = () => {
  
    const signUserOut = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <Text cursor={"pointer"} fontSize="1em" onClick={signUserOut}>SignOut</Text>
    )
}
